import { useState, useEffect } from "react";
import classNames from "classnames";
import styles from "./header.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./../../store";
import { useLocation } from "react-router-dom";
import { DropMenu } from "@art/shared-ui";
import { Chip, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { pageBackTarget, pageBackLabel } from "./page-back-target";
import { getVisibleSettingsCategories } from "./settings-menu";
import NotificationBell from "./notification-bell";
import { currentApplication, getPlanTierLabel } from "../../utils/license";
import { useAttributePermission, usePermissionsContext } from "../../global/permissions";
import ProfileMenuContent, { ProfileAvatar } from "./profile-menu";

export default function HeaderNavbar() {
  const appState = useSelector((state: RootState) => state.appstate);
  const authState = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { has } = usePermissionsContext();
  const visibleSettingsCategories = getVisibleSettingsCategories(has);
  const canUseNotificationInbox = useAttributePermission("APP_MANAGEMENT", "NOTIFICATION_MANAGEMENT", "UseNotificationInbox");
  const [currentContentBar, setCurrentContentBar] = useState("");
  const currentPath = location.pathname;
  const pageLayout = useSelector((state: RootState) => state.pageLayout);
  const ownsBack = pageLayout?.locationKey === location.key && pageLayout.back_navigation === "page";
  const backPath = ownsBack ? null : pageBackTarget(currentPath);
  const isSettingsPage =
    currentPath.startsWith("/application-settings") ||
    currentPath.startsWith("/account-settings") ||
    currentPath.startsWith("/platform-settings");
  const isAppSettingsPage =
    currentPath.startsWith("/application-settings/general") ||
    currentPath.startsWith("/account-settings/general") ||
    currentPath.startsWith("/application-settings/groups") ||
    currentPath.startsWith("/application-settings/messaging");
  const isSuperAdminPage = currentPath.startsWith("/super-admin");
  const { licenseConfig } = useSelector((state: RootState) => state.license);

  const currentPlanLabel = getPlanTierLabel(licenseConfig);

  useEffect(() => {
    if (currentContentBar != "") {
      setCurrentContentBar("");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (currentPath.startsWith("/agent-builder")) {
      currentApplication("art-agent");
    } else if (currentPath.startsWith("/live")) {
      currentApplication("art-live");
    } else if (currentPath.startsWith("/datalake")) {
      currentApplication("art-datalake");
    }
    // else if (currentPath.startsWith("/marketplace")) {
    //   currentApplication("art-marketplace");
    // }
  }, [currentPath]);

  return (
    <div className={classNames("art_card w-100 h-100", styles.art_nav_wrapper)}>
      <div className={styles.art_nav_header}>
        <div className={styles.art_page_identity}>
          {backPath && (
            <IconButton
              aria-label={pageBackLabel(backPath)}
              title={pageBackLabel(backPath)}
              onClick={() => navigate(backPath)}
              size="small"
              sx={{ color: "var(--title-color)", flexShrink: 0 }}
            >
              <ChevronLeftIcon />
            </IconButton>
          )}
          <h1
            className={styles.art_page_title}
            title={appState.page_title || undefined}
          >
            {appState.page_title}
          </h1>
        </div>

        {/* <div className={styles.art_nav_actions}>
          <ul>
            {!isSettingsPage && (
              <li>
                <div
                  className={classNames(styles.art_env_chip, {
                    [styles.production]: appState.environment == "Production",
                  })}
                  onClick={() => navigate("/application-settings/general")}
                >
                  <span>{appState.project_name}</span>
                  <span>{appState.environment}</span>
                </div>
              </li>
            )}

            <li className={styles.setting_icon}>
              <DropMenu
                menuWidth="220px"
                triggerComponent={
                  <span data-qa="header-product-switcher">
                    <FaIcon icon={faTh} className={styles.icon} />
                  </span>
                }
                children={(close: () => void) => (
                  <Box onClick={close}>
                    {productList
                      .filter((product) => {
                        if (!product.role) return true;
                        return userRole?.some(
                          (role: any) => role.name === product.role
                        );
                      })
                      .map((app: any) => {
                        const isActive = currentPath.includes(`/${app.prefix}`);

                        // if (isExternal(app.to)) {
                        //     console.log("external trigger----")
                        //     return (
                        //         <MenuItem
                        //           key={app.key}
                        //           selected={isActive}
                        //           sx={{
                        //             bgcolor: isActive ? "primary.light" : "inherit",
                        //             fontWeight: isActive ? "600" : "normal",
                        //             color: isActive ? "primary.main" : "secondary",
                        //           }}
                        //           data-qa={`drop-menu-${app.key}`}
                        //           onClick={handleLogout}
                        //         >
                        //           {app.title}
                        //         </MenuItem>
                        //       );
                        //     } else {
                        //       return (
                        //         <MenuItem
                        //           key={app.key}
                        //           component={Link}
                        //           to={app.to}
                        //           selected={isActive}
                        //           sx={{
                        //             bgcolor: isActive ? "primary.light" : "inherit",
                        //             fontWeight: isActive ? "600" : "normal",
                        //             color: isActive ? "primary.main" : "secondary",
                        //           }}
                        //           data-qa={`drop-menu-${app.key}`}
                        //         >
                        //           {app.title}
                        //         </MenuItem>
                        //       );
                        //     }

                        return (
                          <MenuItem
                            selected={isActive}
                            sx={{
                              bgcolor: isActive ? "primary.light" : "inherit",
                              fontWeight: isActive ? "600" : "normal",
                              color: isActive ? "primary.main" : "secondary",
                            }}
                            data-qa={`drop-menu-${app?.key}`}
                            component={Link}
                            to={app?.to}
                            onClick={() => {
                              if (app?.key) {
                                localStorage.setItem("app_type", app?.key);
                              }
                            }}
                          >
                            {app?.title}
                          </MenuItem>
                        );
                      })}
                  </Box>
                )}
              ></DropMenu>
            </li>
            <li className={styles.user_profile_wrapper}>
              <DropMenu
                menuWidth="220px"
                triggerComponent={
                  <div className={styles.user_profile}>
                    <div data-qa="header-user-icon">
                      <Identicon
                        size={36}
                        value={authState.user?.email}
                        config={{ backColor: "#ede6e6", padding: 0.12 }}
                        style={{ borderRadius: 2 }}
                      />
                    </div>
                  </div>
                }
                children={(close: () => void) => (
                  <Box onClick={close}>
                    {generalMenuItems.map((item, index) => {
                      if (item.divider)
                        return <Divider key={`divider-${index}`} />;

                      if (!item.to) return null;

                      const isActive = location.pathname === item.to;
                      const isExternal = item.title === "Add Worksapce";

                      return (
                        <MenuItem
                          key={item.to}
                          selected={isActive}
                          component={!isExternal ? Link : "a"}
                          to={!isExternal ? item.to : undefined}
                          href={isExternal ? "#" : undefined}
                          onClick={
                            isExternal
                              ? () => handleCreateWorkspace()
                              : undefined
                          }
                          data-qa={`drop-menu-${item.dataQa}`}
                          sx={{
                            bgcolor: isActive ? "primary.light" : "inherit",
                            fontWeight: isActive ? "600" : "normal",
                            color: isActive ? "primary.main" : "secondary",
                          }}
                        >
                          {item.title}
                        </MenuItem>
                      );
                    })}
                  </Box>
                )}
              ></DropMenu>
            </li>
          </ul>
        </div> */}
        <div className={styles.desktop_only_actions}>
          <div className={styles.art_nav_actions}>
            <ul>
              {currentPlanLabel !== "Sandbox" && (
                <li>
                  <Chip
                    label={`${currentPlanLabel} Plan`}
                    size="small"
                    className={styles.plan_badge}
                  />
                </li>
              )}
              {!isSuperAdminPage && (!isSettingsPage || isAppSettingsPage) && (
                <li>
                  <div
                    className={classNames(styles.art_env_chip, {
                      [styles.production]: appState.environment == "Production",
                    })}
                    onClick={() => navigate("/application-settings/general")}
                  >
                    <span>{appState.project_name || "No Project"}</span>
                    <span>{appState.environment || "No Environment"}</span>
                  </div>
                </li>
              )}

              {canUseNotificationInbox && <li className={styles.setting_icon}>
                <NotificationBell />
              </li>}

              <li className={styles.user_profile_wrapper}>
                <DropMenu
                  menuWidth="min(324px, calc(100vw - 20px))"
                  menuPadding="0"
                  triggerComponent={
                    <button
                      type="button"
                      className={styles.user_profile}
                      aria-label="Open profile menu"
                      title="Profile"
                      data-qa="header-user-icon"
                    >
                      <ProfileAvatar
                        user={authState.user}
                        size={36}
                        className={styles.user_profile_image}
                      />
                    </button>
                  }
                  children={(close: () => void) => (
                    <ProfileMenuContent
                      user={authState.user}
                      tenantName={authState.tenantName}
                      categories={visibleSettingsCategories}
                      pathname={location.pathname}
                      onNavigate={close}
                    />
                  )}
                ></DropMenu>
              </li>

              {/* End wrapper */}
            </ul>
          </div>
        </div>

        {canUseNotificationInbox && (
          <div className={styles.mobile_only_actions}>
            <NotificationBell />
          </div>
        )}
      </div>
      {/* <div className={classNames(styles.content_bar, { [styles.active]: currentContentBar != "" && currentContentBar != "notifications" })}> */}
      {/* <div className="row">

                <Box sx={{ flexGrow: 1 }}>
                    <ul className={`d-flex flex-wrap align-items-center justify-content-center ${styles.featured_product_block}`}>
                        <Grid2 container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            {productList.filter((product) => {
                                if (!product.role) return true;
                                return userState?.tenant?.roles?.some((role: any) => role.name === product.role);
                            }).map(({ key, to, imgSrc, title, description }) => {
                                const isActive = key === activeAppType;
                                return (
                                    <Grid2 size={{ xs: 12, md: 6, lg: 4 }} key={key} className={styles.card_wrapper}>
                                        <Card elevation={0} sx={{ borderRadius: 2 }}
                                            className={`h-100 ${isActive ? styles.active_card : ''}`}
                                            onClick={() => {
                                                localStorage.setItem('app_type', key);
                                                setActiveAppType(localStorage.getItem('app_type'));
                                            }}
                                        >
                                            {to ? (
                                                <NavLink to={to}>
                                                    <div className={styles.product_block}>
                                                        <div className={styles.product_logo}>
                                                            <img src={imgSrc} alt={title} className="art_app_logo_full img_fit_contain" />
                                                        </div>
                                                        <p>{description}</p>
                                                    </div>
                                                </NavLink>
                                            ) : (
                                                <div className={styles.product_block}>
                                                    <div className={styles.product_logo}>
                                                        <img src={imgSrc} alt={title} className="art_app_logo_full img_fit_contain" />
                                                    </div>
                                                    <p>{description}</p>
                                                </div>
                                            )}
                                        </Card>
                                    </Grid2>
                                );
                            })}
                        </Grid2>
                    </ul>
                </Box> */}

      {/* Need to implement after marketplace */}
      {/* {false && (
                    <div className="col-12 col-md-6 col-lg-4">
                        <h2 className={styles.submenu_title}>
                            My Products
                        </h2>
                        <ul className={styles.my_product_wrapper}>
                            <li>
                                <NavLink to={"/live/dashboard"}>
                                    <div className={styles.app_block}>
                                        <div className={styles.app_image}>
                                            <img
                                                src="/assets/images/art_logo_short.svg"
                                                className={classNames(styles.art_app_logo_short, "img_fit_contain")}
                                                alt="Description of the image"
                                            />
                                        </div>
                                        <h3>Anonymisor</h3>
                                    </div>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={"dashboard"}>
                                    <div className={styles.app_block}>
                                        <div className={styles.app_image}>
                                            <img
                                                src="/assets/images/art_logo_short.svg"
                                                className="art_app_logo_short img_fit_contain"
                                                alt="Description of the image"
                                            />
                                        </div>
                                        <h3>Anonymisor</h3>
                                    </div>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={"/live/dashboard"}>
                                    <div className={styles.app_block}>
                                        <div className={styles.app_image}>
                                            <img
                                                src="/assets/images/art_logo_short.svg"
                                                className="art_app_logo_short img_fit_contain"
                                                alt="Description of the image"
                                            />
                                        </div>
                                        <h3>Anonymisor</h3>
                                    </div>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                )}
                <div className="col-12 col-md-6 col-lg-3"></div> */}
      {/* </div> */}

      {/* </div> */}
    </div>
  );
}
